// The farm's "game" look (owner, 2026-09-29: "buttons are just sharp corners, it looks like pure
// HTML"): one palette and a few sizing rules shared by gameUi.js. Pure (node --test).
export const PALETTE = {
  panel: { fill: 0xfff3dc, border: 0x8d5a2b, inner: 0xffffff, shadow: 0x000000 },
  // wood serves both the title strips / tiles (fill, dark, light) and the wooden button variant
  wood: { fill: 0xb57a43, dark: 0x7a4b24, light: 0xd9a066, text: '#fff8e8', stroke: '#5a3414', face: 0xb57a43, lip: 0x6e4220, top: 0xd9a066 },
  primary: { face: 0x6cbf45, lip: 0x3f8a25, top: 0x9be07a, text: '#ffffff', stroke: '#2d6b19' },
  secondary: { face: 0xf2d38a, lip: 0xc59a3e, top: 0xfbe9bd, text: '#5a3a12', stroke: null },
  danger: { face: 0xe0604d, lip: 0xa8382a, top: 0xf29a8c, text: '#ffffff', stroke: '#7a241a' },
  dark: { face: 0x3d2a1a, lip: 0x1f140b, top: 0x5c4130, text: '#fff8e8', stroke: null },
  disabled: { face: 0xcfc7b8, lip: 0x9d9587, top: 0xe4ded2, text: '#8a8378', stroke: null },
};
export const RADIUS = { panel: 22, button: 14, card: 16 };
export const LIP = 5;                     // px of darker "3D" edge under a button
// The label's y inside a gameButton: the middle of the face (owner, 2026-09-29: it sat LIP/2
// too high), riding down with the face when pressed.
export function buttonLabelY({ pressed = false } = {}) { return pressed ? LIP - 1 : 0; }
export const FONT = 'system-ui, -apple-system, "Segoe UI", sans-serif';

export function buttonColors(variant = 'primary', { enabled = true } = {}) {
  return enabled ? (PALETTE[variant] ?? PALETTE.primary) : PALETTE.disabled;
}

// Width for a pop-up menu: the longest line plus padding, kept between 180 and 420 px.
export function menuWidth(lines, measure, { pad = 48, min = 180, max = 420 } = {}) {
  const w = Math.max(...lines.map((l) => measure(l))) + pad;
  return Math.max(min, Math.min(max, Math.ceil(w)));
}

// Width of a progress bar's fill: 0 when empty, at least `height` once there is any progress (a
// rounded pill never collapses into a square speck), never wider than the track.
export function progressFillWidth(frac, width, height) {
  const f = Number.isFinite(frac) ? Math.max(0, Math.min(1, frac)) : 0;
  if (f === 0) return 0;
  return Math.min(width, Math.max(height, Math.round(width * f)));
}
